var _rect, _path, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillPProgram = function SvgFillPProgram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66.667,
    height: 46.667,
    x: 6.667,
    y: 13.334,
    fill: "#C7DEFE",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A8AFB6",
    d: "M31.667 60h16.667v10H31.667z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26.667,
    height: 5,
    x: 26.667,
    y: 65,
    fill: "#C8CED4",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8CED4",
    d: "M6.667 51.668h66.666v4.333a4 4 0 0 1-4 4H10.667a4 4 0 0 1-4-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B70F9",
    d: "m57.848 31.458-3.075-1.373c.153-.829.24-1.701.24-2.573 0-.873-.087-1.701-.218-2.508l3.074-1.352c1.112-.48 1.592-1.766 1.112-2.878l-1.22-2.748c-.48-1.112-1.767-1.591-2.879-1.112l-3.074 1.352a15.3 15.3 0 0 0-2.508-2.53l1.374-3.074c.501-1.09 0-2.398-1.09-2.878l-2.748-1.221a2.17 2.17 0 0 0-2.878 1.09l-1.374 3.075c-.829-.153-1.7-.24-2.573-.24-.872 0-1.7.087-2.508.218L36.153 9.63c-.48-1.112-1.767-1.591-2.879-1.112L30.526 9.74c-1.112.48-1.592 1.767-1.112 2.879l1.352 3.074a15.3 15.3 0 0 0-2.53 2.508l-3.074-1.374a2.17 2.17 0 0 0-2.878 1.09l-1.221 2.748a2.17 2.17 0 0 0 1.09 2.878l3.074 1.374c-.152.828-.24 1.7-.24 2.573 0 .872.088 1.7.218 2.507l-3.074 1.352c-1.112.48-1.592 1.766-1.112 2.878l1.22 2.748c.48 1.112 1.767 1.592 2.88 1.112l3.074-1.352c.741.938 1.57 1.788 2.507 2.53l-1.373 3.074a2.17 2.17 0 0 0 1.09 2.878l2.747 1.221c1.09.502 2.399 0 2.878-1.09l1.374-3.074c.829.152 1.701.24 2.573.24.873 0 1.701-.088 2.508-.219l1.352 3.075c.48 1.112 1.766 1.592 2.878 1.112l2.748-1.221c1.111-.48 1.591-1.766 1.111-2.878l-1.351-3.075a15.3 15.3 0 0 0 2.529-2.508l3.075 1.374c1.09.502 2.398 0 2.878-1.09l1.22-2.748c.502-1.09 0-2.398-1.09-2.878M40.01 36.103a8.58 8.58 0 0 1-8.591-8.591 8.58 8.58 0 0 1 8.591-8.592 8.58 8.58 0 0 1 8.591 8.592 8.58 8.58 0 0 1-8.59 8.59"
  })));
};
export default SvgFillPProgram;